import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15789dcd"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, " 请选择设备绑定合约机！只能綁定借款人账号下的设备或未激活设备，未激活设备绑定合约机后只能由借款人进行激活！ ", -1))
const _hoisted_2 = { class: "list-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "设备列表", -1))
const _hoisted_4 = {
  key: 0,
  class: "icon-checked"
}
const _hoisted_5 = { class: "info" }
const _hoisted_6 = { class: "code" }
const _hoisted_7 = { class: "model-name" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "empty-text xag-flex-center"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", null, "暂无设备")
], -1))
const _hoisted_11 = [
  _hoisted_10
]

import { v4 as uuidv4 } from 'uuid'
import { computed, onMounted, ref, Ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { List, Checkbox, CheckboxGroup } from 'vant'
import { commonErrorHandle } from '@/utils/error-handle'
import { getClientDeviceList } from '@/apis/agricultura-loan'
import type { MyEquipmentItem, ApplyFormPackageSelectionsItem } from '@/types/agricultura-loan'
import {
  UnActivetedSnsStorage,
  ConfirmBindDeviceInfoStorage,
  PackageSelectionCodeMapStorage,
  CurrentPackageSelectionInfoStorage,
} from '@/storage/agricultura-loan'
import useCommonList, { PageListResut } from '@/compositions/useCommonList'
import AppHeader from '@/components/Header.vue'
import IconArrowRightWrap from '@/components/icon/IconArrowRightWrap.vue'
import UnactivedDevicePopup from './components/unactived-device-popup.vue'
import CommonFooterNextButton from '@/components/CommonFooterNextButton.vue'
import { BooleanObject } from '@/types/public'
import { showNormalToast } from '@/utils/tools'


export default /*#__PURE__*/_defineComponent({
  __name: 'device-list',
  setup(__props) {

const popupVisible = ref(false)
const $route = useRoute()
const $router = useRouter()
const unActivetedList = ref(UnActivetedSnsStorage.get<MyEquipmentItem[]>() || [])

const code = $route.query.code as string
const uuid = $route.query.uuid as string
const max = Number($route.query.num as string)
const snList = (($route.query.sns as string) || '').split(',').filter((val) => val)

const unSelectDeviceSnMap: Ref<BooleanObject> = ref({})

const selectedValue: Ref<string[]> = ref(snList)

function getCanUseCodeMap(): BooleanObject {
  return PackageSelectionCodeMapStorage.get() || {}
}
async function queryList(params: any): Promise<PageListResut<MyEquipmentItem>> {
  try {
    const data = await getClientDeviceList()
    return {
      data,
      current_page: 1,
      total: data.length,
    }
  } catch (error) {
    commonErrorHandle(error)
    return Promise.reject(error)
  }
}

const { loading, requestError, finished, dataList, queryHandle, finishedText } = useCommonList<
  MyEquipmentItem,
  any
>(queryList, {
  emptyText: '暂无设备',
})

const renderList = computed(() => {
  const codeMap = getCanUseCodeMap()
  const hasCodeKeys = Object.keys(codeMap).length > 0
  return unActivetedList.value
    .concat(dataList.value)
    .map((item) => {
      return {
        ...item,
        uuid: uuidv4(),
      }
    })
    .filter((item) => !unSelectDeviceSnMap.value[item.serial_number])
    .filter((item) => (hasCodeKeys ? codeMap[item.material_code] : true))
})
// 检查是否可选
function checkItemDisabled(item: MyEquipmentItem) {
  return selectedValue.value.length >= max && selectedValue.value.indexOf(item.serial_number) === -1
}
// 点击不可选设备
function deviceClickHandle(item: MyEquipmentItem) {
  if (checkItemDisabled(item)) {
    showNormalToast(`当前最多选择${max}个设备`)
  }
}
// 添加未激活设备
function confirmAddUnActiveDevice(data: MyEquipmentItem) {
  const unActivetedSnList = UnActivetedSnsStorage.get<Array<MyEquipmentItem>>() || []
  const newList = [
    {
      ...data,
    },
    ...unActivetedSnList,
  ]
  UnActivetedSnsStorage.set(newList)
  unActivetedList.value = newList
  selectedValue.value.push(data.serial_number)
  // 直接返回去添加该设备
  ConfirmBindDeviceInfoStorage.set({
    uuid,
    mode: 'add',
    list: [
      {
        serial_number: data.serial_number,
      },
    ],
  })
  $router.go(-1)
}

// 确认使用当前使用的设备
function confirmHandle() {
  const selectedValueMap = selectedValue.value.reduce((result, value) => {
    result[value] = true
    return result
  }, {} as BooleanObject)
  ConfirmBindDeviceInfoStorage.set({
    uuid,
    mode: 'edit',
    list: renderList.value
      .filter((item) => selectedValueMap[item.serial_number])
      .map((renderItem) => {
        return {
          ...renderItem,
        }
      }),
  })
  $router.go(-1)
}

onMounted(() => {
  const data: ApplyFormPackageSelectionsItem[] = CurrentPackageSelectionInfoStorage.get() || []
  if (!data) {
    return
  }
  // 其他套餐已绑定的序列号，标记为不可选
  unSelectDeviceSnMap.value = data
    .filter((item) => item.uuid !== uuid)
    .reduce((result, item) => {
      const sns = item.sns
      sns.forEach(({ serial_number }) => {
        result[serial_number] = true
      })
      return result
    }, {} as BooleanObject)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "我的设备" }),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(IconArrowRightWrap, {
        class: "un-active-device",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (popupVisible.value = true))
      }, {
        default: _withCtx(() => [
          _createTextVNode("添加未激活设备")
        ]),
        _: 1
      })
    ]),
    _createVNode(_unref(List), {
      loading: _unref(loading),
      "onUpdate:loading": _cache[2] || (_cache[2] = ($event: any) => (_isRef(loading) ? (loading).value = $event : null)),
      error: _unref(requestError),
      "onUpdate:error": _cache[3] || (_cache[3] = ($event: any) => (_isRef(requestError) ? (requestError).value = $event : null)),
      finished: _unref(finished),
      offset: 200,
      "finished-text": _unref(finishedText),
      "error-text": "加载失败",
      onLoad: _unref(queryHandle),
      class: _normalizeClass(["list-container", _unref(renderList).length === 0 ? 'empty-wrap' : ''])
    }, {
      finished: _withCtx(() => [
        (_unref(renderList).length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(renderList).length && _unref(dataList).length === 0 ? '没有更多了' : _unref(finishedText)), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(CheckboxGroup), {
          modelValue: selectedValue.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedValue).value = $event))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(renderList), (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "deivce-item van-hairline--bottom",
                key: item.serial_number
              }, [
                _createVNode(_unref(Checkbox), {
                  class: "checkbox-item",
                  name: item.serial_number,
                  disabled: checkItemDisabled(item),
                  onClick: ($event: any) => (deviceClickHandle(item))
                }, {
                  icon: _withCtx((props) => [
                    (props.checked)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: _normalizeClass(["icon-unchecked", props.disabled ? 'disabled-item' : ''])
                        }, null, 2))
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, "设备编码：" + _toDisplayString(item.serial_number), 1),
                      _createElementVNode("div", _hoisted_7, _toDisplayString(item?.name || ''), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["name", "disabled", "onClick"])
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["loading", "error", "finished", "finished-text", "onLoad", "class"]),
    _createVNode(CommonFooterNextButton, {
      title: "确定",
      onClick: confirmHandle
    }),
    _createVNode(UnactivedDevicePopup, {
      visible: popupVisible.value,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((popupVisible).value = $event)),
      code: _unref(code),
      onConfirm: confirmAddUnActiveDevice
    }, null, 8, ["visible", "code"])
  ], 64))
}
}

})